/**
 * Development Councils Translations (Spanish)
 * @module developmentCouncils
 * @language es
 */

export const developmentCouncils = {
  developmentCouncils: {
    title: "Consejos de Desarrollo de JCI",
    subtitle: "Cuatro Pilares Regionales para Crecimiento & Desarrollo",
    description: "Los Consejos de Desarrollo de Área de JCI trabajan junto al Consejo de Directores de JCI y la Sede de JCI para servir como pilares regionales para el desarrollo de liderazgo, el crecimiento organizacional y el impacto sostenible en todo el mundo.",

    heroBadge: "Expansión Global de JCI",
    networkGrowthBadge: "Crecimiento de la Red JCI",

    overview: {
      title: "Visión Global",
      description: "Estos consejos representan las divisiones geográficas estratégicas de JCI, trabajando juntos para desarrollar líderes para un mundo cambiante.",
      councilsCount: "4 Consejos de Área",
      regionsServed: "Todos los Continentes"
    },

    sections: {
      mission: "Misión",
      strategicGoals: "Objetivos Estratégicos 2025",
      keyAchievements: "Logros Clave",
      keyMetrics: "Métricas Clave",
      recommendations: "Recomendaciones 2026",
      highlights: "Destacados 2025"
    },

    councils: {
      adc: {
        name: "Consejo de Desarrollo Americano",
        abbreviation: "ADC",
        region: "América",
        mission: "Mostrar acciones que aumenten la visibilidad de la marca JCI, impulsen el crecimiento y retención de miembros, y proporcionen experiencias de liderazgo de desarrollo global a los miembros.",
        goals: {
          brandAwareness: {
            name: "Conciencia de Marca y Visibilidad",
            description: "Aumentar el engagement en plataformas de redes sociales y promover las actividades de JCI.",
            achievements: [
              "30% de aumento en el engagement en redes sociales",
              "2 artículos publicados en JCI Lead Magazine",
              "Etiquetas estratégicas e interacciones mejoradas"
            ]
          },
          leadershipDevelopment: {
            name: "Desarrollo de Liderazgo",
            description: "Formar y desarrollar nuevos líderes en toda la región de las Américas.",
            achievements: [
              "Reunión de Presidentes Nacionales con 68% de participación (17 Presidentes)",
              "Academia de Liderazgo Americano 25° aniversario con 77% de participación",
              "27 nuevos líderes formados con más de 30 horas de contenido",
              "Programa de Capacitación en Liderazgo con 8 sesiones"
            ]
          },
          sustainableStructure: {
            name: "Estructura Abierta, Eficiente y Sostenible",
            description: "Apoyar el desarrollo y expansión de Organizaciones Nacionales.",
            achievements: [
              "Chile presentado como Organización Potencial de JCI",
              "Guatemala apoyada hacia estatus Provisional",
              "Conferencia de Club Junior con 250 registros"
            ]
          }
        },
        metrics: {
          socialMedia: { label: "Crecimiento en Redes Sociales", value: "30%" },
          membership: { label: "Meta de Membresía", value: "5%" },
          bestPractices: { label: "Encuesta de Mejores Prácticas", value: "834" },
          leadersTrained: { label: "Líderes Formados", value: "27" }
        },
        highlights: [
          "Academia de Liderazgo Americano celebró su 25° aniversario",
          "Primer Evento Global en Línea sobre Compartir Mejores Prácticas",
          "Lanzamiento de Conferencia de Club Junior con liderazgo ADC"
        ]
      },
      edc: {
        name: "Consejo de Desarrollo Europeo",
        abbreviation: "EDC",
        region: "Europa",
        mission: "Fomentar una cultura que apoye el crecimiento, la innovación y la colaboración entre Organizaciones Nacionales en 41 regiones de Europa.",
        goals: {
          valueProposition: {
            name: "Propuesta de Valor",
            description: "Crear campañas trimestrales en redes sociales dirigidas al grupo demográfico de 18-40 años.",
            achievements: [
              "+8,896 nuevos seguidores de enero a noviembre",
              "9,789 publicaciones realizadas",
              "5,176 compartidos logrados"
            ]
          },
          geographicExpansion: {
            name: "Expansión Geográfica",
            description: "Establecer presencia de JCI en nuevas regiones.",
            achievements: [
              "Meta: 3 nuevas regiones geográficas para el Q3",
              "Apoyando nuevas organizaciones potenciales",
              "Expandiendo dentro de Organizaciones Nacionales existentes"
            ]
          },
          knowledgeSharing: {
            name: "Intercambio de Conocimientos",
            description: "Organizar programas que permitan la colaboración cruzada.",
            achievements: [
              "4 programas de intercambio de conocimientos organizados",
              "Programa de mentoría renovado con colaboración ASE",
              "24 equipos de mentoreados inscritos"
            ]
          },
          productDevelopment: {
            name: "Desarrollo de Nuevos Productos",
            description: "Lanzar herramientas para desarrollar capítulos locales sostenibles.",
            achievements: [
              "JCI Serious Game desarrollado y probado",
              "7 países participaron en pruebas de prototipo",
              "Puntuación de satisfacción promedio de 4.5/5"
            ]
          }
        },
        metrics: {
          followers: { label: "Nuevos Seguidores", value: "+8,896" },
          academyParticipants: { label: "Participantes de Academia", value: "158+" },
          gameSatisfaction: { label: "Satisfacción del Juego", value: "4.5/5" },
          regionsCovered: { label: "Regiones Cubiertas", value: "41" }
        },
        highlights: [
          "Prototipo de JCI Serious Game probado en 7 países",
          "Academia de Liderazgo Mediterráneo (31 participantes)",
          "Academia Europea en Suecia (99 participantes)",
          "Academia Tri Naciones (Irlanda, Reino Unido, Escocia)",
          "Academia Balcánica (7 países, 14 participantes)"
        ]
      },
      amdec: {
        name: "Consejo de Desarrollo de África y Medio Oriente",
        abbreviation: "AMDEC",
        region: "África y el Medio Oriente",
        mission: "Empoderar a jóvenes líderes emprendedores en África y Medio Oriente para impulsar un cambio positivo a través del desarrollo de liderazgo, asociaciones estratégicas y soluciones innovadoras.",
        goals: {
          anniversary: {
            name: "Celebraciones del 40° Aniversario",
            description: "Conmemorar cuatro décadas de impacto y liderazgo en toda la región.",
            achievements: [
              "Campaña digital 40 Años de Impacto lanzada",
              "Ceremonias de reconocimiento para líderes pasados y actuales",
              "Iniciativas lanzadas para sostener el legado de AMDEC"
            ]
          },
          skillsDevelopment: {
            name: "Capacitación y Desarrollo de Habilidades",
            description: "Implementar capacitaciones mensuales en áreas operativas clave.",
            achievements: [
              "Capacitación en Gestión Financiera y Presupuestos",
              "Reuniones Efectivas y Procedimientos Parlamentarios",
              "Gestión de Proyectos y Evaluación de Impacto",
              "Marca Personal y Desarrollo de Liderazgo"
            ]
          },
          strategicCollaboration: {
            name: "Colaboración Estratégica",
            description: "Superar barreras lingüísticas y fomentar la colaboración regional.",
            achievements: [
              "Serie JCI Lusófona lanzada para países de habla portuguesa",
              "Conferencia de Club Junior con 100+ asistentes en línea",
              "Serie de Juegos JCI en asociación con EDC y JCI Francia"
            ]
          }
        },
        metrics: {
          yearsOfImpact: { label: "Años de Impacto", value: "40" },
          newMarkets: { label: "Nuevos Mercados", value: "2" },
          conferenceAttendees: { label: "Asistentes a Conferencia", value: "100+" },
          trainingTopics: { label: "Temas de Capacitación", value: "4+" }
        },
        highlights: [
          "Celebraciones del 40° Aniversario en toda la región",
          "Reunión de Presidentes Nacionales en Mauricio",
          "27ª Academia JCI África y Medio Oriente",
          "Serie JCI Lusófona conectando naciones de habla portuguesa",
          "Kenia completó hito de registro gubernamental"
        ]
      },
      apdc: {
        name: "Consejo de Desarrollo Asia-Pacífico",
        abbreviation: "APDC",
        region: "Asia y el Pacífico",
        mission: "Expandir la presencia de JCI y actuar como un factor positivo en el desarrollo regional a través de la misión de JCI.",
        goals: {
          strategicPlan: {
            name: "Ejecución del Plan Estratégico",
            description: "Compartir y ejecutar el Marco de Acción de JCI y el Plan Estratégico 2023-2027.",
            achievements: [
              "12 misiones realizadas a países objetivo",
              "Colaboración con otros Consejos de Desarrollo",
              "Plan estructurado a través de reuniones trimestrales"
            ]
          },
          countryEmpowerment: {
            name: "Empoderamiento de Países",
            description: "Empoderar a los países asignados hacia la afiliación o graduación.",
            achievements: [
              "6 nuevas Organizaciones Locales afiliadas",
              "1 Organización Nacional declarada",
              "356+ miembros reclutados",
              "Bases sostenibles en administración y finanzas"
            ]
          },
          countryDevelopment: {
            name: "Desarrollo Específico por País",
            description: "Programas de desarrollo dirigidos para cada país.",
            achievements: [
              "Tailandia: 20% de crecimiento en membresía (150→180)",
              "Myanmar: Recaudación de 11,000 USD para Ayuda por Terremoto",
              "Sri Lanka: Primera Convención Nacional después del renacimiento",
              "Uzbekistán: Crecimiento de 46 a 60 miembros"
            ]
          }
        },
        metrics: {
          membersRecruited: { label: "Miembros Reclutados", value: "356+" },
          newLocalOrgs: { label: "Nuevas Orgs Locales", value: "6" },
          missionsConducted: { label: "Misiones Realizadas", value: "12" },
          nationalOrgs: { label: "Orgs Nacionales", value: "1" }
        },
        highlights: [
          "JCI Tailandia logró 85% en Índice de Desempeño de Sostenibilidad",
          "Proyecto de Ayuda por Terremoto de Myanmar ayudó a 500+ individuos",
          "Sri Lanka realizó primera Convención Nacional",
          "Timor-Leste conectó con 9 organizaciones asociadas",
          "Desarrollo de Laos iniciado con asociación YEAL"
        ]
      }
    },

    comparativeAnalysis: {
      title: "Análisis Comparativo",
      subtitle: "Cómo se comparan los cuatro consejos en dimensiones clave",
      categories: {
        geographicCoverage: {
          name: "Cobertura Geográfica",
          adc: "América Central y del Sur, Caribe, Norteamérica",
          edc: "41 regiones, concentradas en centros universitarios",
          amdec: "40+ años de presencia regional",
          apdc: "Myanmar, Tailandia, Sri Lanka, Timor-Leste, Uzbekistán, Laos"
        },
        strategicPriorities: {
          name: "Prioridades Estratégicas",
          adc: "Visibilidad de marca a través de redes sociales, metas de crecimiento de membresía",
          edc: "Expansión geográfica, intercambio de conocimientos, productos innovadores",
          amdec: "Legado institucional, estructuras fundamentales, nuevos mercados",
          apdc: "Empoderamiento de países, misiones dirigidas, construcción de capacidades"
        },
        leadershipDevelopment: {
          name: "Desarrollo de Liderazgo",
          adc: "Reuniones de Presidentes Nacionales, Academia de Liderazgo Americano",
          edc: "Academias regionales, programas de mentoría, juegos serios",
          amdec: "Academias de Liderazgo, capacitaciones mensuales, mentoría",
          apdc: "Misiones específicas por país, talleres especializados"
        }
      }
    },

    keyHighlights: {
      title: "Destacados 2025",
      subtitle: "Principales logros e innovaciones de todos los consejos",
      items: {
        seriousGame: {
          title: "JCI Serious Game",
          description: "Herramienta de aprendizaje interactivo desarrollada por EDC, probada en 7 países con calificación de satisfacción de 4.5/5."
        },
        juniorClub: {
          title: "Conferencia de Club Junior",
          description: "Iniciativa entre consejos con 250+ registros, inspirando a jóvenes aspirantes a JCI."
        },
        anniversary: {
          title: "40° Aniversario de AMDEC",
          description: "Cuatro décadas de impacto celebradas con campañas digitales y ceremonias de reconocimiento."
        },
        apdcGrowth: {
          title: "Hito de Crecimiento APDC",
          description: "356+ miembros reclutados, 6 nuevas Organizaciones Locales afiliadas, 12 misiones estratégicas realizadas."
        },
        lusophoneSeries: {
          title: "Serie JCI Lusófona",
          description: "Conectando países de habla portuguesa incluyendo Angola, Cabo Verde, Guinea Bissau y más."
        }
      }
    },

    newNationalOrganizations: {
      title: "Nuevas Organizaciones Nacionales",
      subtitle: "Expandiendo nuestra red global con comunidades JCI emergentes",
      potential: {
        title: "Potencial",
        description: "Explorando afiliación a JCI y estableciendo estructuras fundamentales"
      },
      provisional: {
        title: "Provisional",
        description: "Construyendo membresía y cumpliendo estándares JCI para afiliación plena"
      },
      fullAffiliation: {
        title: "Afiliación Plena",
        description: "Recientemente alcanzó el estatus de miembro pleno en la red global JCI"
      },
      countries: {
        angola: "JCI Angola",
        djibouti: "JCI Yibuti",
        chile: "JCI Chile",
        gambia: "JCI Gambia",
        sriLanka: "JCI Sri Lanka",
        portugal: "JCI Portugal",
        myanmar: "JCI Myanmar",
        armenia: "JCI Armenia"
      }
    },

    chairperson: "Presidente",
    learnMore: "Saber Más",
    viewDetails: "Ver Detalles",
    source: "Fuente: Informe Integral de los Consejos de Desarrollo JCI 2025"
  }
} as const;
